import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";

import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      collectioname: "",
      folders: [],
      files: [],
      success: false,
      collections: [],
      selectedCollections: [],
      company: this.$store.state.company,
      error: false,
      theerror: "",
      state: 1,
      mySpace: 0,
    };
  },
  created() {
    this.folders = this.$store.state.transferItems.selectedFolders;
    this.files = this.$store.state.transferItems.selectedFiles;

    this.mySpace = this.folders[0]
      ? this.folders[0].myspace
      : this.files[0].myspace;

    this.$axios
      .get(baseUrl + "/collectionsall?myspace" + this.mySpace)
      .then((response) => {
        this.collections = response.data;
      });
  },
  methods: {
    collectNew() {
      let formData = new FormData();

      formData.append("collectionname", this.collectioname);
      formData.append(
        "files",
        JSON.stringify(this.files.map((file) => file.id))
      );
      formData.append("myspace", this.mySpace === undefined ? 0 : this.mySpace);

      this.$axios
        .post(baseUrl + "/collectionadd", formData)
        .then((response) => {
          if (
            response.data.success == false &&
            response.data.msg == "collection_exists"
          ) {
            this.error = true;
            this.theerror = i18n.t("collection.collection_already_exists");
          } else if (
            response.data.success == false &&
            response.data.msg == "folder_exists"
          ) {
            this.error = true;
            this.theerror = i18n.t(
              "collection.collection_already_exists_folder"
            );
          } else if (
            response.data.success == false &&
            response.data.msg == "file_exists"
          ) {
            this.error = true;
            this.theerror = i18n.t("collection.collection_already_exists_file");
          } else {
            this.success = true;
            this.theerror = "";
            this.error = false;
            EventBus.$emit("clearSelection");
            EventBus.$emit("collectioncount");
            this.$axios
              .get(baseUrl + "/collectionsall?myspace" + this.mySpace)
              .then((response) => {
                this.collections = response.data;
              });
          }

          //this.$root.$refs.navigation_sidebar.showCollectedBadge();
        });
    },
    collectExisting() {
      let formData = new FormData();

      formData.append("collections", JSON.stringify(this.selectedCollections));
      formData.append(
        "files",
        JSON.stringify(this.files.map((file) => file.id))
      );
      formData.append("myspace", this.mySpace === undefined ? 0 : this.mySpace);

      this.$axios
        .post(baseUrl + "/collectionaddmultiple", formData)
        .then((response) => {
          if (
            response.data.success == false &&
            response.data.msg == "collection_exists"
          ) {
            this.error = true;
            this.theerror = i18n.t("collection.collection_already_exists");
          }
          if (
            response.data.success == false &&
            response.data.msg == "folder_exists"
          ) {
            this.error = true;
            this.theerror = i18n.t(
              "collection.collection_already_exists_folder"
            );
          }
          if (
            response.data.success == false &&
            response.data.msg == "file_exists"
          ) {
            this.error = true;
            this.theerror = "collection.collection_already_exists_file";
          } else {
            this.success = true;
            this.theerror = "";
            this.error = false;
            EventBus.$emit("clearSelection");
            this.$axios
              .get(baseUrl + "/collectionsall?myspace" + this.mySpace)
              .then((response) => {
                this.collections = response.data;
              });
          }

          //this.$root.$refs.navigation_sidebar.showCollectedBadge();
        });
    },
    close() {
      EventBus.$emit("closeallactions");
    },

    transitionHandler() {},
  },
  beforeMount() {
    if (this.user != null) {
      this.$axios
        .get(baseUrl + "/collectionsall?myspace" + this.mySpace)
        .then((response) => {
          this.collections = response.data;
        });
    }
  },
};
